import { MouseEventHandler } from "react";
import styled from "styled-components";

type PanelAreaFieldProps = {
  colors: string[];
  clickHandle: Function;
  columnStart: number;
  rowStart: number;
  areaFieldSelected: boolean;
};

const PanelAreaField = ({
  colors,
  clickHandle,
  columnStart,
  rowStart,
  areaFieldSelected,
}: PanelAreaFieldProps): React.ReactElement => {
  const colorFields = colors.map((color: string, ind: number) => {
    return (
      <DivColorField
        $backgroundColor={color}
        key={`color_field_${ind}`}
        id={`area_field_${rowStart}_${columnStart}_${ind}`}
      ></DivColorField>
    );
  });
  return (
    <DivAreaField
      id={`area_field_${rowStart}_${columnStart}`}
      onClick={clickHandle as MouseEventHandler<HTMLDivElement>}
      $areaFieldSelected={areaFieldSelected}
    >
      {colorFields}
    </DivAreaField>
  );
};

const DivAreaField = styled.div<{
  $backgroundColor?: string;
  $areaFieldSelected: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.$backgroundColor ?? "white"};
  cursor: ${(props) => (props.$backgroundColor ? "pointer" : "auto")};
  border: ${(props) =>
    props.$areaFieldSelected ? "0.14rem dashed grey" : "none"};
`;

const DivColorField = styled.div<{ $backgroundColor?: string }>`
  position: absolute;
  top: 0rem;
  left: 0rem;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background-color: ${(props) => props.$backgroundColor ?? "white"};
  cursor: ${(props) => (props.$backgroundColor ? "pointer" : "auto")};
`;

export default PanelAreaField;
